import { createFileRoute } from '@tanstack/react-router';

import { getLaboratoryOptions } from '@/module/Laboratory';

export const Route = createFileRoute(
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout',
)({
  loader: async ({ params: { labId }, context: { queryClient } }) => {
    const laboratory = await queryClient.ensureQueryData(getLaboratoryOptions(labId));

    return {
      laboratory,
      crumb: laboratory.name,
    };
  },
});
